import React from 'react';
import useStyle from './podiumBlock.style';
import { BadgeAvatar } from '../../Badges/BadgeAvatar';
import { BadgeRanking } from '../../Badges/BadgeRanking';
import { ImagesLots } from '../../../../types/Lots';
import { UserPosition } from '../../../../types/leaderboard/leaderboard';

export type TopPosition = 1 | 2 | 3;

interface PodiumBlockProps {
  user: UserPosition;
  lot?: ImagesLots;
}

export const PodiumBlock = ({ user, lot }: PodiumBlockProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <BadgeAvatar user={user} variant={'leaderboard'} />
      <BadgeRanking
        note={user.moyennegenerale}
        position={user.rank}
        lot={lot}
      />
    </div>
  );
};
